export const strings = {
  signin_page_title: 'Oturum Aç',
  signup_page_title: 'Kaydol',
  forgot_password_page_title: 'Şifremi Unuttum',
  signin: 'Oturum Aç',
  signingin: 'Giriş yapılıyor',
  forgot_password_link: 'Şifrenizi mi unuttunuz?',
  password: 'Şifre',
  username: 'E-posta/Kullanıcı Adı',
  enter_password: '8 karakterden fazla girin',
  enter_username: 'E-posta/Kullanıcı Adı Girin',
  send_link: 'Link Gönder',
  back_to_signin: 'Oturum Açmaya Geri Dön',
  sending_link: 'Link gönderiliyor',
  enter_email: 'E-posta Girin',
  email: 'E-posta',
  will_send_recovery:
    'Şifrenizi sıfırlamak için bir bağlantı içeren bir kurtarma e-postası göndereceğiz.',
  reset_password: 'Şifre Sıfırlama',
  set_password: 'Şifre Belirleme',
  join_group: 'Gruba Katıl',
  new_password: 'Yeni Şifre',
  new_password_placeholder: 'Yeni Şifre Girin',
  retype_new_password: 'Yeni Parolayı Yeniden Yazın',
  cancel: 'İptal',
  save: 'Kaydet',
  saving: 'Kaydediliyor',
  signup: 'Kaydol',
  signup_help_text:
    'Uygulama lisansınızla kaydolun ve tam erişime sahip doğrulanmış bir hesap edinin.',
  signingup: 'Kaydolunuyor',
  email_address: 'E-posta Adresi',
  email_address_placeholder: 'E-posta adresini girin',
  country: 'Ülke',
  country_placeholder: 'Ülke Seçiniz',
  phone_number_optional: 'Telefon Numarası (İsteğe Bağlı)',
  phone_number_optional_placeholder: 'Numara Girin',
  profession: 'Meslek',
  speciality: 'Uzmanlık',
  speciality_placeholder: 'Uzmanlık Seçin',
  license_no: 'Lisans Kimliği',
  license_no_placeholder: 'Ör. DK7654321IN',
  email_placeholder: 'Ör. johnsmith@email.com',
  license_files: 'Lisans Belgesi',
  license_files_placeholder: 'Bir ek yükleyin',
  password_placeholder: '8 karakterden fazla girin',
  phone_number: 'Telefon numarası',
  phone_number_placeholder: 'Telefon Numarasını Girin',
  password_help_text:
    'Harflerin, sayıların ve sembollerin bir karışımı ile 8 veya daha fazla karakter kullanın',
  iqvia_hcp_space: 'IQVIA SMM Alanı',
  iqvia_hcp_space_subtext: 'Sağlık hizmetleri için en hızlı büyüyen ağ',
  free_register: 'Kayıt ücretsizdir. Bugün kaydolun',
  connect_with_peers:
    'Meslektaşlarınızla bağlantı kurun ve güncellemeleri paylaşın',
  webinar_with_kol: "KOL'ler tarafından yürütülen webinarlar",
  sign_up_cme: "CME'lere kaydolun",
  share_update: 'Tıbbi vakaları güvenli bir ortamda tartışın',
  confirm_password: 'Şifreyi Onayla',
  errors: {
    is_required: 'gereklidir',
    first_name_required: 'İsminiz gereklidir',
    last_name_required: 'Soyadınız gereklidir',
    designation_required: 'Atama gereklidir',
    about_required: 'Hakkımda gerekli',
    interests_required: 'En az bir ilgi alanı seçmeniz gerekir',
    username_required: 'Kullanıcı adı/E-posta gereklidir',
    email_required: 'E-posta gereklidir',
    password_required: 'Şifre gereklidir',
    incorrect_user: 'E-posta biçimi doğru değil',
    password_mismatch: 'Her iki şifre de aynı olmalıdır',
    password_length: 'Şifre 8 karakterden uzun olmalıdır',
    license_no_required: 'Lisans kimliği gereklidir',
    license_files_required: 'Lisans Dosyası gereklidir',
    country_id_required: 'Ülke gereklidir',
    tnc_required: 'Şartlar ve Koşulları kabul etmelisiniz',
    phone_required: 'Telefon numarası gereklidir',
    license_id_required: 'Lisans kimliği gereklidir',
    verification_document_required: 'Lisans belgesi gereklidir',
    profession_id_required: 'Meslek gereklidir',
    speciality_id_required: 'Uzmanlık gerekli',
    phone_code_required: 'Telefon kodu gereklidir',
    title_required: 'Başlık gereklidir',
  },
  connect_people: 'İnsanlarla Bağlantı Kurun',
  build_network: 'Ağınızı Oluşturun',
  join_groups: 'Gruplara Katılma',
  next: 'İleri',
  finish: 'Bitirmek',
  skip: 'Atla',
  back: 'Geri',
  personal: 'Kişisel',
  work: 'İş',
  optional: 'İsteğe bağlı',
  license: 'Lisans',
  profile_details: 'Profil Detayları',
  setup_profile: 'Profilinizi Oluşturun',
  tnc: 'Hüküm ve koşullar',
  i_agree_to: 'Ben de katılıyorum',
  retype_your_password: 'Yeni şifrenizi tekrar girin',
  enter_password_more_than: '8 karakterden fazla girin',
  set_new_password: 'Yeni şifre belirle',
  phone_tooltip: 'Pozitif Tamsayı olmalıdır',
  enter_phone: 'Numara giriniz',
  password_lowercase_auth: 'Şifreniz en az bir küçük harf içermelidir',
  password_uppercase_auth: 'Şifreniz en az bir büyük harf içermelidir',
  password_number_auth: 'Şifreniz en az bir rakam içermelidir',
  password_character_auth: 'Şifreniz *,@,_, #',
  password_limit_auth: 'Şifreniz en az 8 karakterden oluşmalıdır',
  password_success_status: 'Şifre başarıyla değiştirildi',
  current_password: 'Mevcut Şifre',
  current_password_place: 'Mevcut şifreyi girin',
  primary: 'Birincil',
  secondary_email: 'İkincil e-posta adresi',
  send_code: 'Doğrulama Kodu Gönder',
  selected: 'Seçilmiş',
  help_provide_great_experience:
    'Size harika bir deneyim sunmamıza yardımcı olun',
  provide_work_details:
    'Sizi doğru meslektaşlarınızla buluşturabilmemiz için çalışma ayrıntılarınızı sağlayın',
  enrich_your_experience:
    "Meslektaşlarınızla bağlantı kurarak SMM Space'teki deneyiminizi zenginleştirin",
  become_part_specialised_group:
    'Bilginizi tartışmak ve geliştirmek için özel grupların bir parçası olun',
  ots_title: 'Tek Seferlik Giriş Yap',
  ots_label:
    'Parolasız oturum açmanız için size tek seferlik bir oturum açma bağlantısı e-postası göndereceğiz.',
  ots_success:
    "CAVI'ye giriş yapmak için kullanabileceğiniz bir bağlantı içeren bir e-posta gönderdik {email}",
  one_time_sign_in_link: 'Bana tek seferlik bir oturum açma bağlantısı gönder',
  sign_in_using_pwd: 'Bunun yerine şifre ile oturum açın',
  sign_in_using_otl:
    'Tek Seferlik Oturum Açma Bağlantısını Kullanarak Oturum Açın',
  have_sent_recovery:
    'Sağlanan adrese {email} bir bağlantı içeren bir e-posta gönderdik, bu e-posta ile bir hesabınız varsa şifrenizi sıfırlamak için bir bağlantı içeren bir e-posta alacaksınız. Şifrenizi sıfırlamak için e-postadaki bağlantıya tıklayın',
  password_reset_success:
    'Şifreniz başarıyla değiştirildi. Bu yeni şifreyi kullanarak hesabınıza giriş yapın',
  update_password: 'Şifreyi Güncelle',
  updating: 'güncelleniyor',
  creating_account: 'İşleniyor',
  verify_email: 'E-posta Doğrulandı',
  verify_email_success:
    'E-postanızı başarıyla doğruladınız, ana sayfaya gitmek için aşağıdaki düğmeye tıklayın',
  back_to_home: 'Ana sayfaya dön',
  sign_up_success: 'Kayıt Başarılı',
  check_email_post_signup:
    'Lütfen e-postanızı kontrol edin ve CAVi\'ye erişiminizi etkinleştirmek için sağlanan talimatları izleyin. Birkaç dakika içinde e-postayı görmezseniz, lütfen "gereksiz posta" klasörünüzü veya "spam" klasörünüzü kontrol edin',
  terms_condition_signup: '{tnc} ve {privacy_policy} kabul ediyorum',
  privacy_policy: 'Gizlilik Politikası',
  close: 'Kapalı',
  email_verification_sent:
    'Bir doğrulama bağlantısı e-postanıza gönderildi {email}',
  email_verification_sent_2:
    'Lütfen e-postanızı doğrulayın, e-postayı almadıysanız',
  click_here: 'Buraya Tıklayın',
  send_mail: 'e-postayı gönder',
  session_title: 'Oturum sona ermek üzere',
  session_body:
    'Bir süredir hareketsizsiniz, mevcut oturumunuz sona ermek üzere ve otomatik olarak çıkış yapılacaksınız',
  default_language: 'Varsayılan Dil',
  language_id_required: 'Dil gereklidir',
  i_agree: 'Kabul ediyorum',
  or: 'Veya',
};
